// Onthoudt opgehaalde gegevens zodat pagina's direct openen in plaats van
// steeds opnieuw te laden. Blijft binnen hetzelfde tabblad ook na verversen
// bewaard; verouderde gegevens worden op de achtergrond bijgewerkt.
const PREFIX = "infra-cache-";
const TTL_MS = 12 * 60 * 60 * 1000;

const memory = new Map();

export function getCached(key) {
  if (memory.has(key)) return memory.get(key);
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    if (!raw) return undefined;
    const { t, v } = JSON.parse(raw);
    if (Date.now() - t > TTL_MS) {
      sessionStorage.removeItem(PREFIX + key);
      return undefined;
    }
    memory.set(key, v);
    return v;
  } catch (e) {
    return undefined;
  }
}

export function setCached(key, value) {
  memory.set(key, value);
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify({ t: Date.now(), v: value }));
  } catch (e) {
    /* opslag vol of niet beschikbaar: geheugen volstaat */
  }
}

export function clearCache() {
  memory.clear();
  try {
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch (e) {
    /* niets te wissen */
  }
}
